import { useContext } from 'react';
import { keyframes } from '@emotion/react';

import { Box, IconButton, Tooltip, useTheme } from '@mui/material';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';
import { SidebarContext } from 'src/contexts/SidebarContext';

const pulseAnimation = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
`;

function Toggle() {
	const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
	const theme = useTheme();

	return (
		<Box
			component="span"
			sx={{
				m: 2,
				display: { lg: 'none', xs: 'inline-block' }
			}}
		>
			<Tooltip arrow title={sidebarToggle ? "Tutup Menu" : "Lihat Menu"}>
				<IconButton
					color="primary"
					onClick={toggleSidebar}
					id="sidebar-toggle"
					sx={{
						backgroundColor: theme.palette.mode === 'dark'
							? theme.palette.action.selected
							: 'rgba(0, 0, 0, 0.05)',
						border: `1px solid ${theme.palette.divider}`,
						borderRadius: '8px',
						padding: '8px',
						animation: `${pulseAnimation} 2s ease-in-out 3`,
						'&:hover': {
							backgroundColor: theme.palette.action.hover,
						},
						fontSize: '1rem',
						gap: '5px',
					}}
				>
					{!sidebarToggle ? (
						<MenuTwoToneIcon fontSize="small" />
					) : (
						<CloseTwoToneIcon fontSize="small" />
					)}
					Menu
				</IconButton>
			</Tooltip>
		</Box>
	);
}

export default Toggle;